import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  base: '/qby',
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      name: "qby",
      path: "/",
      component: () => import("./views/index"),
      meta: {
        title: "首页",
        keepAlive: true,
      }
    },
    {
      name: "gw",
      path: "/",
      component: () => import("./views/index"),
      meta: {
        title: "首页",
        keepAlive: true,
      }
    },
    {
      name: "ns",
      path: "/ns",
      component: () => import("./views/ll/index"),
      meta: {
        title: "预告",
        keepAlive: true
      }
    },
    {
      name: "ii",
      path: "/ii",
      component: () => import("./views/ll/index"),
      meta: {
        title: "预告",
        keepAlive: true
      }
    },
    {
      name: "zb",
      path: "/zb",
      component: () => import("./views/ll/index"),
      meta: {
        title: "预告",
        keepAlive: true
      }
    },
    {
      name: "gg",
      path: "/gg",
      component: () => import("./views/gg/index"),
      meta: {
        title: "预告",
        keepAlive: true
      }
    },
    ,
    {
      name: "new",
      path: "/new",
      component: () => import("./views/new/index"),
      meta: {
        title: "预告",
        keepAlive: true
      }
    }
  ]
});
